<script setup>
import TenantFaqTable from '@frontJs/components/tables/projectManagement/TenantFaqTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>{{ tenant.name }} - FAQ - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle>
        Gestion de projet - FAQ -
        {{ tenant.name }}
    </PageTitle>

    <TenantFaqTable :tenant="tenant" />
</template>
